import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Image,
  Row,
  Select,
  Tooltip,
} from "antd";

import { useContext, useEffect, useState } from "react";
import { BASE_BE_URL, SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { ALMSG_INTERNAL_ERR, ALMSG_TIMEOUT, BASE_ITASK_SUBURL } from "../env";
import { emptyStudio, Studio } from "./interfaces";
import { editStudio, getStudioLogoImg, uploadNewLogo } from "./utils";

const { Option } = Select;

const layout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

const EditStudioInfo = ({
  baseStudio,
  setBaseStudio,
}: {
  baseStudio: Studio;
  setBaseStudio?: Function;
}) => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [editError, setEditError] = useState("");
  const [editSuccess, setEditSuccess] = useState("");

  const [studio, setStudio] = useState(baseStudio);

  const [form] = Form.useForm();
  const [compiledBase, setCompiledBase] = useState(false);
  const [modalLogoVisible, setModalLogoVisible] = useState(false);

  const [selectedLogo, setSelectedLogo] = useState<File>();
  const [logo64, setLogo64] = useState<string>();

  useEffect(() => {
    //every time that medical studio data changes, check validity of required fields
    const validFullName: boolean =
      studio.fullName != undefined && studio.fullName.length >= 2;
    //const validVat: boolean =
    //  studio.vat != undefined && studio.vat.length == 11;
    const validLogoURL: boolean =
      studio.logo != undefined && studio.logo.length >= 4;
    setCompiledBase(validFullName /*&& validVat */ && validLogoURL);
  }, [studio, signedInDoctor]);

  useEffect(() => {
    if (editError != "") setTimeout(() => setEditError(""), ALMSG_TIMEOUT);
    if (editSuccess != "") setTimeout(() => setEditSuccess(""), ALMSG_TIMEOUT);
  }, [editError, editSuccess]);

  useEffect(() => {
    getStudioLogoImg(signedInDoctor, studio).then((blob) => {
      console.log(blob);
      if (blob) setLogo64(URL.createObjectURL(blob));
    });
  }, [studio]);

  //update studio data
  const updateStudioData = (successMsg?: string) => {
    editStudio(signedInDoctor, studio)
      .then((studioOpString: string) => {
        try {
          const sId: number = parseInt(JSON.parse(studioOpString).id);
          if (!isNaN(sId) && sId == studio.id) {
            setStudio({ ...studio });
            if (setBaseStudio != undefined) setBaseStudio(studio);
            setEditError("");
            setEditSuccess(
              successMsg || "I dati dello studio medico sono stati aggiornati"
            );
          } else setEditError(ALMSG_INTERNAL_ERR);
        } catch (err: any) {
          setEditError(studioOpString);
        }
      })
      .catch(() => setEditError(ALMSG_INTERNAL_ERR));
  };

  //update Logo
  const updateLogoSubmit = () => {
    if (selectedLogo != undefined)
      uploadNewLogo(signedInDoctor, studio, selectedLogo).then(
        (newLogoResp: string) => {
          try {
            const newLogoName = JSON.parse(newLogoResp).filename;

            updateStudioData("Logo aggiornato");
            //logo upload success
            setStudio({ ...studio, logo: newLogoName }); //this trigger useEffect above for uploading img string
          } catch (err) {
            setEditError(newLogoResp);
          }

          setModalLogoVisible(false);
        }
      );
  };

  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        //Computer
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          initialValues={{ ...studio }}
          onFinish={() => updateStudioData()}
          layout="vertical"
        >
          <Row>
            <Col span={10}>
              <Form.Item
                name="nameSignIn"
                label="Login name"
                rules={[{ required: true }]}
              >
                <Input
                  required
                  disabled
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, nameSignIn: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={4}>
              <Form.Item label="Logo" rules={[{ required: true }]}>
                <Input type={"hidden"} required value={studio.logo} />
                <Button onClick={() => setModalLogoVisible(true)}>
                  Aggiorna logo
                </Button>
              </Form.Item>

              <Modal
                title="Carica un nuovo logo"
                centered
                open={modalLogoVisible}
                footer={false}
                onOk={() => setModalLogoVisible(false)}
                onCancel={() => setModalLogoVisible(false)}
                width={480}
                style={{ textAlign: "center", margin: "auto" }}
              >
                <Image
                  className="img-resized"
                  src={logo64}
                  preview={false}
                  fallback="data:image/png;base64,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"
                />
                <form encType="multipart-form-data">
                  <Input
                    type={"file"}
                    accept={"image/*"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (e && e.target && e.target.files)
                        setSelectedLogo(e.target.files[0]);
                    }}
                  />
                </form>
                <Button
                  htmlType="button"
                  style={{ background: "green", color: "white" }}
                  onClick={updateLogoSubmit}
                  disabled={selectedLogo == undefined}
                >
                  Aggiorna
                </Button>
              </Modal>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <Form.Item
                name="fullName"
                label="Nome intero"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Nome dello studio medico"
                  required
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, fullName: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={6}>
              <Form.Item
                name="vat"
                label="Partita IVA"
                rules={[{ required: false }]}
              >
                <Input
                  placeholder="Partita IVA"
                  required
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, vat: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <Form.Item name="street" label="Indirizzo">
                <Input
                  placeholder="Via"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, street: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={2}>
              <Form.Item name="streetNumber" label="Civico">
                <Input
                  placeholder="N° civico"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, streetNumber: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <Form.Item name="city" label="Comune di residenza">
                <Input
                  placeholder="Comune di residenza"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, city: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={4}>
              <Form.Item name="cap" label="CAP">
                <Input
                  placeholder="CAP"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, cap: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={4}>
              <Form.Item name="province" label="Provincia">
                <Input
                  placeholder="Provincia"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, province: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={7}>
              <Form.Item name="email" label="Email">
                <Input
                  type={"email"}
                  placeholder="email"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, email: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={7}>
              <Form.Item name="telephoneD" label="Telefono">
                <Input
                  type={"text"}
                  placeholder="telefono"
                  addonBefore={"+39"}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, telephone: "+39" + e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col span={8}>
              <Form.Item name="websiteD" label="Website">
                <Input
                  type={"text"}
                  placeholder="website"
                  addonBefore={"http://"}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({
                      ...studio,
                      website: "http://" + e.target.value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ margin: "auto", textAlign: "right" }}>
            <Tooltip
              placement="top"
              title={
                !compiledBase ? "Compila correttamente i dati richiesti!" : ""
              }
            >
              <Button
                className="ant-btn-ghost"
                htmlType="button"
                onClick={() => updateStudioData()}
                disabled={!compiledBase}
                style={{ background: "green", color: "white", margin: "2px" }}
              >
                AGGIORNA
              </Button>
            </Tooltip>
          </Form.Item>
          <Form.Item>
            {editError && (
              <Alert
                message="Operazione non riuscita"
                description={editError}
                type="error"
                showIcon
              />
            )}
            {!editError && editSuccess && (
              <Alert
                message="Operazione riuscita"
                description={editSuccess}
                type="success"
                showIcon
              />
            )}
          </Form.Item>
        </Form>
      )}
      {width <= 640 && (
        //Mobile
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          initialValues={{ ...studio }}
          onFinish={() => updateStudioData()}
          layout="vertical"
        >
          <Row>
            <Col span={12}>
              <Form.Item
                name="nameSignIn"
                label="Login name"
                rules={[{ required: true }]}
              >
                <Input
                  required
                  disabled
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, nameSignIn: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={0.5} />
            <Col span={11}>
              <Form.Item label="Logo" rules={[{ required: true }]}>
                <Input type={"hidden"} required value={studio.logo} />
                <Button onClick={() => setModalLogoVisible(true)}>
                  Aggiorna logo
                </Button>
              </Form.Item>

              <Modal
                title="Carica un nuovo logo"
                centered
                open={modalLogoVisible}
                footer={false}
                onOk={() => setModalLogoVisible(false)}
                onCancel={() => setModalLogoVisible(false)}
                width={480}
                style={{ textAlign: "center", margin: "auto" }}
              >
                <Image
                  className="img-resized"
                  src={logo64}
                  preview={false}
                  fallback="data:image/png;base64,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"
                />
                <form encType="multipart-form-data">
                  <Input
                    type={"file"}
                    accept={"image/*"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (e && e.target && e.target.files)
                        setSelectedLogo(e.target.files[0]);
                    }}
                  />
                </form>
                <Button
                  htmlType="button"
                  style={{ background: "green", color: "white" }}
                  onClick={updateLogoSubmit}
                  disabled={selectedLogo == undefined}
                >
                  Aggiorna
                </Button>
              </Modal>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                name="fullName"
                label="Nome intero"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Nome dello studio medico"
                  required
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, fullName: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={0.5} />
            <Col span={11}>
              <Form.Item
                name="vat"
                label="Partita IVA"
                rules={[{ required: false }]}
              >
                <Input
                  placeholder="Partita IVA"
                  required
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, vat: e.target.value })
                  }
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="street" label="Indirizzo">
                <Input
                  placeholder="Via"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, street: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={0.5} />
            <Col span={6}>
              <Form.Item name="streetNumber" label="Civico">
                <Input
                  placeholder="N° civico"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, streetNumber: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item name="province" label="Provincia">
                <Input
                  placeholder="Provincia"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, province: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={15}>
              <Form.Item name="city" label="Comune di residenza">
                <Input
                  placeholder="Comune di residenza"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, city: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={0.5} />
            <Col span={6}>
              <Form.Item name="cap" label="CAP">
                <Input
                  placeholder="CAP"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, cap: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={0.5} />

            <Col span={24}>
              <Form.Item name="email" label="Email">
                <Input
                  type={"email"}
                  placeholder="email"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, email: e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="telephoneD" label="Telefono">
                <Input
                  type={"text"}
                  placeholder="telefono"
                  addonBefore={"+39"}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({ ...studio, telephone: "+39" + e.target.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="websiteD" label="Website">
                <Input
                  type={"text"}
                  placeholder="website"
                  addonBefore={"http://"}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setStudio({
                      ...studio,
                      website: "http://" + e.target.value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ margin: "auto", textAlign: "right" }}>
            <Tooltip
              placement="top"
              title={
                !compiledBase ? "Compila correttamente i dati richiesti!" : ""
              }
            >
              <Button
                className="ant-btn-ghost"
                htmlType="button"
                onClick={() => updateStudioData()}
                disabled={!compiledBase}
                style={{ background: "green", color: "white", margin: "2px" }}
              >
                AGGIORNA
              </Button>
            </Tooltip>
          </Form.Item>
          <Form.Item>
            {editError && (
              <Alert
                message="Operazione non riuscita"
                description={editError}
                type="error"
                showIcon
              />
            )}
            {!editError && editSuccess && (
              <Alert
                message="Operazione riuscita"
                description={editSuccess}
                type="success"
                showIcon
              />
            )}
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default EditStudioInfo;
